// extracted by mini-css-extract-plugin
export var externalLink = "_7r-0";
export var internalLinkLabel = "_7r-1";